import React from 'react';
import { Image } from '../../commonTypes/image';
import colors from '../../helpers/colors';
import componentProps, { ComponentProps } from '../../helpers/componentProps';
import { applyComponentTheme } from '../../theme';
import { Grid, GridItem } from '../Grid';
import RichText from '../RichText';
import {
  AuthorImage,
  AuthorInfoContainer,
  AuthorInfoContent,
  AuthorName,
  Heading,
} from './styles';

export type AuthorInfoProps = {
  author: string;
  image: Image;
  body: string;
  // for backwards compatibility, we treat undefined as true here as that was the original behaviour
  showAuthorPrefix?: boolean;
} & ComponentProps;

const AuthorInfo: React.FC<AuthorInfoProps> = ({
  author,
  image,
  body,
  showAuthorPrefix,
  ...props
}) => (
  <Grid {...componentProps(props)}>
    <GridItem desktop={10} tabletLandscape={10}>
      <AuthorInfoContainer tabIndex={0}>
        <AuthorImage image={image} />
        <AuthorInfoContent>
          <Heading tabIndex={0}>
            {showAuthorPrefix === false ? '' : 'By'} <AuthorName>{author}</AuthorName>
          </Heading>
          <RichText html={body} backgroundColor={colors.neutral07} focusable />
        </AuthorInfoContent>
      </AuthorInfoContainer>
    </GridItem>
  </Grid>
);

export default applyComponentTheme(AuthorInfo, 'AuthorInfo');
